module.exports = __webpack_public_path__ + "static/img/4.85ca9d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eg/4.png
// module id = 124
// module chunks = 2